webpackJsonp([81199602302203],{

/***/ 974:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"sos on the mindsweeper","www_url":"http://www.deptford.tv","thema":"SOS","issue_month":"October","issue_year":2007,"issue_date":200710,"artist":"deptfordtv","location":"Großbritannien","email":"info@deptford.tv","id":"contribution_322","media_type":"moving_image","position_in_section":1,"media_uri":"media/2007/October/moving_image/mind.mov","media_th_uri":"","still_image_count":4,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_322"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200710-moving-image-1-6b20db4a731052c5afea.js